module.exports = __webpack_public_path__ + "static/slide1-ad44cf074e42d67936a3dce4d2a09f1a.png";